import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import Reveal, { EASE } from "./Reveal";

export default function Portfolio() {
  return (
    <section
      id="portfolio"
      data-testid="portfolio-section"
      className="px-6 py-28 sm:px-[8vw] sm:py-40"
    >
      <p className="f-mono mb-4 text-[11px] tracking-[0.35em] text-[#B8860B]">
        PORTFOLIO &mdash; COMPANIES OF THE HOLDING
      </p>
      <Reveal>
        <h2 className="f-display max-w-2xl text-3xl font-light tracking-tight text-slate-900 sm:text-5xl">
          Built to last. <span className="italic text-[#B8860B]">Owned to grow.</span>
        </h2>
      </Reveal>

      <div className="mt-16 grid gap-5 lg:grid-cols-2">
        <motion.article
          data-testid="portfolio-card-arcymo"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-10% 0px" }}
          transition={{ duration: 0.95, ease: EASE }}
          whileHover={{ y: -6 }}
          className="group border border-slate-200 bg-white/70 backdrop-blur-sm transition-shadow duration-500 hover:border-[#D4AF37]/50 hover:shadow-[0_24px_60px_rgba(212,175,55,0.14)]"
        >
          <div className="flex items-center justify-center border-b border-slate-100 px-10 py-12">
            <img
              src="/arcymo.png"
              alt="ARCYMO Smart Textiles Logo"
              className="w-full max-w-[320px] transition-transform duration-700 group-hover:scale-[1.02]"
            />
          </div>
          <div className="p-8 sm:p-10">
            <div className="flex items-baseline justify-between gap-4">
              <h3 className="f-display text-2xl font-light tracking-wide text-slate-900 sm:text-3xl">
                ARCYMO GmbH
              </h3>
              <span className="f-mono text-[10px] tracking-[0.3em] text-[#B8860B]">
                SMART TEXTILES
              </span>
            </div>
            <p className="mt-6 text-base font-light leading-relaxed text-slate-600">
              We are ARCYMO &mdash; a manufacturer of innovative textiles. We combine
              new ideas with functional materials and develop textile solutions for
              demanding applications. Along the way, we question the status quo and
              push possibilities further.
            </p>
            <p className="mt-4 text-base font-light leading-relaxed text-slate-600">
              Sustainability and continuous innovation shape our standards: choosing
              materials consciously, developing durable solutions and constantly
              improving products. This is how we create textiles that unite function,
              quality and a responsible use of resources.
            </p>
            <div className="mt-8 flex items-center justify-between border-t border-[#D4AF37]/30 pt-4">
              <p className="f-mono text-[10px] tracking-[0.3em] text-slate-500">
                01 &mdash; A COMPANY OF SYPAMA HOLDING GMBH
              </p>
              <a
                data-testid="arcymo-website-link"
                href="https://www.arcymo.com"
                target="_blank"
                rel="noopener noreferrer"
                className="f-mono flex items-center gap-2 text-[10px] tracking-[0.25em] text-slate-700 transition-colors duration-300 hover:text-[#B8860B]"
              >
                WWW.ARCYMO.COM
                <ArrowUpRight className="h-3.5 w-3.5 text-[#D4AF37]" />
              </a>
            </div>
          </div>
        </motion.article>

        <motion.div
          data-testid="portfolio-card-next"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-10% 0px" }}
          transition={{ duration: 0.95, delay: 0.15, ease: EASE }}
          className="flex flex-col items-center justify-center border border-dashed border-slate-300 p-10 text-center"
        >
          <span className="f-mono text-[10px] tracking-[0.35em] text-slate-400">02</span>
          <p className="f-display mt-6 text-2xl font-light italic text-slate-400 sm:text-3xl">
            The next chapter is unwritten.
          </p>
          <p className="f-mono mt-6 text-[10px] tracking-[0.3em] text-slate-400">
            FUTURE PORTFOLIO COMPANY
          </p>
        </motion.div>
      </div>
    </section>
  );
}
